<nav class="main-verticale-navigation">
    <a href="" class="logo">
        <img src="/logo.svg" alt="Logo">
    </a>
    <ul class="main-navigation">
        <p>ADMINISTRATIE</p>
        <li [ngClass]="{'active': current === 'dashboard'}">
            <a class="btn-nav" routerLink="./dashboard">
                <i class="bi bi-speedometer"></i>
                <span>
                    Dashboard
                </span>
            </a>
        </li>
        <li [ngClass]="{'active': current === 'orders'}">
            <a class="btn-nav" routerLink="./orders">
                <i class="bi bi-cart-fill"></i>
                <span>
                    Bestellingen
                </span>
            </a>
        </li>
        <li [ngClass]="{'active': current === 'school'}">
            <a class="btn-nav" routerLink="./school/list">
                <i class="bi bi-building-fill"></i>
                <span>
                    Scholen
                </span>
            </a>
            <ul class="submenu">
                <li [ngClass]="{'active': current === 'school' && current2 === 'list'}">
                    <a href="#" routerLink="./school/list">Scholen</a>
                </li>
                <li [ngClass]="{'active': current === 'user' && current2 === 'list'}">
                    <a href="" routerLink="./user/list">Gebruikers</a>
                </li>
            </ul>
        </li>
        <p class="mt-5">PLATFORM BEHEER</p>
        <li [ngClass]="{'active': current === 'course'}">
            <a class="btn-nav" routerLink="./course/list">
                <i class="bi bi-gear-fill"></i>
                <span>
                    Methodes
                </span>
            </a>
            <ul class="submenu">
                <li *ngFor="let course of courses" [ngClass]="{'active': current2 === 'course'}">
                    <a [routerLink]="'./course/details/' + course['id']">{{course.title}}</a>
                </li>
            </ul>
        </li>
        <li [ngClass]="{'active': current === 'settings'}">
            <a class="btn-nav" routerLink="./settings/subjects">
                <i class="bi bi-gear"></i>
                <span>
                    Instellingen
                </span>
            </a>
            <ul class="submenu">
                <li [ngClass]="{'active': current2 === 'subjects'}">
                    <a routerLink="./settings/subjects">Vakken</a>
                </li>
                <li [ngClass]="{'active': current2 === 'authors'}">
                    <a routerLink="./settings/authors">Auteurs</a>
                </li>
                <li [ngClass]="{'active': current2 === 'studies'}">
                    <a routerLink="./settings/studies">Studies</a>
                </li>
                <li [ngClass]="{'active': current2 === 'studyLevels'}">
                    <a routerLink="./settings/studyLevels">Niveau's</a>
                </li>
                <li [ngClass]="{'active': current2 === 'periods'}">
                    <a routerLink="./settings/periods">Periodes</a>
                </li>
            </ul>
        </li>
        <li [ngClass]="{'active': current === 'product'}">
            <a class="btn-nav" routerLink="./product/list">
                <i class="bi bi-box-seam-fill"></i>
                <span>
                    Producten
                </span>
            </a>
        </li>
        <li [ngClass]="{'active': current === 'clients'}">
            <a class="btn-nav" routerLink="./clients">
                <i class="bi bi-plugin"></i>
                <span>
                    Apps
                </span>
            </a>
        </li>
        <li [ngClass]="{'active': current === 'queue-messages'}">
            <a class="btn-nav" routerLink="./queue-messages/list">
                <i class="bi bi-database"></i>
                <span>
                    Messages
                </span>
            </a>
        </li>
        <li [ngClass]="{'active': current === 'platform-status'}">
            <a class="btn-nav" routerLink="./platform-status">
                <i class="bi bi-cloud-check"></i>
                <span>
                    Platform status
                </span>
            </a>
        </li>
    </ul>
</nav>